import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-base-component',
    templateUrl: './base-component.component.html',
    styleUrls: ['./base-component.component.css'],
    standalone: false
})
export class BaseComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
